import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import MuiLineChart from "./MuiLineChart.tsx";
import MuiMultiLineChart from "./MuiMultiLineChart.tsx";
import MuiPieChart from "./MuiPieChart.tsx";
import MuiBarChart from "./MuiBarChart.tsx";

const OverviewCharts: React.FC = () => {
  // Chart 1: Leads Over Time
  const leadsDates = ["May 24", "May 27", "May 30", "Jun 4", "Jun 9", "Jun 12", "Jun 15", "Jun 18", "Jun 21"];
  const leadsValues = [9, 3, 6, 7, 10, 9, 6, 5, 4];

  // Chart 2: Lead Velocity (multi-line)
  const velocityDates = ["May 18", "May 25", "Jun 1", "Jun 8", "Jun 15"];
  const totalLeads = [20, 38, 29, 39, 37];
  const conversionRates = [0, 35, 26, 30, 13.5];

  // Chart 3: Status Distribution (Pie)
  const statusData = [
    { id: 1, value: 29.2, label: "Converted" },
    { id: 2, value: 23.4, label: "New" },
    { id: 3, value: 24.0, label: "Qualified" },
    { id: 4, value: 23.4, label: "Lost" },
  ];

  // Chart 4: Campaign ROI (Bar)
  const campaignLabels = ["Summer Sale", "Brand Awareness", "Retargeting", "Product Launch"];
  const campaignSeries = [
    {
      data: [95000, 125000, 110000, 160000],
      label: "Revenue",
      color: "#4caf50",
    },
  ];

  return (
    <Grid container spacing={2}>
      {/* Chart 1: Leads Over Time */}
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Leads Over Time
          </Typography>
          <MuiLineChart xLabels={leadsDates} yData={leadsValues} label="Leads" color="#3e59e3" />
        </Paper>
      </Grid>

      {/* Chart 2: Lead Velocity */}
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Lead Velocity
          </Typography>
          <MuiMultiLineChart
            xLabels={velocityDates}
            series={[
              { data: totalLeads, label: "Total Leads", color: "#3e59e3" },
              { data: conversionRates, label: "Conversion Rate", color: "#4caf50" },
            ]}
          />
        </Paper>
      </Grid>

      {/* Chart 3: Status Distribution */}
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Status Distribution
          </Typography>
          <MuiPieChart data={statusData} />
        </Paper>
      </Grid>

      {/* Chart 4: Campaign ROI */}
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Campaign ROI
          </Typography>
          <MuiBarChart xLabels={campaignLabels} series={campaignSeries} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default OverviewCharts;
